export default "__VITE_ASSET__3cb5c1f8__"